import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';
import Button from '../Button';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	const formattedDate = new Date(post.post_date).toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
	});

	return (
		<a href={post.permalink} target="_self" rel="noreferrer" className="pfa-card-default">
			<div className="pfa-card-default__text  container">
				{(post.category.name || formattedDate) && (
					<div className="pfa-card-default__meta-container">
						{post.category.name && (
							<span
								className="pfa-card-default__tag post-tag"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(post.category.name),
								}}
							/>
						)}

						{formattedDate && (
							<span
								className="pfa-card-default__date post-date"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(formattedDate),
								}}
							/>
						)}
					</div>
				)}
				<div className="pfa-card-default__content">
					{post.post_title && (
						<h3
							className="pfa-card-default__title"
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
						/>
					)}
					<div className="pfa-card-default__context">
						{post.post_excerpt && (
							<p
								className="pfa-card-default__excerpt"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(post.post_excerpt),
								}}
							/>
						)}
						<Button className="pfa-card-default__link btn-tertiary" text="Read More" />
					</div>
				</div>
			</div>
		</a>
	);
};

Default.displayName = 'Default';

export default Default;
